import { defineMessages } from 'react-intl';

const messages: {
	daysNotInRange: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	hoursNotInRange: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	monthsNotInRange: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	validationMessageBeforeGreaterThanAfter: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	validationMessageInvalidDateFormat: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	validationMessageMissingDate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	validNumber: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	weeksNotInRange: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	yearsNotInRange: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	validationMessageBeforeGreaterThanAfter: {
		id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after`,
		defaultMessage: "'Before' field cannot be later than 'After' field.",
		description:
			'Message displayed to the user when the Before date used is greater than the after date while specifying dates',
	},
	validationMessageInvalidDateFormat: {
		id: `eoc.alert-list.common.utils.validation-message-invalid-date-format`,
		defaultMessage: 'Invalid date format.',
		description: 'Invalid date format.',
	},
	validationMessageMissingDate: {
		id: `eoc.alert-list.common.utils.validation-message-missing-date`,
		defaultMessage: 'Please provide at least one valid date.',
		description:
			'Validation message shown in the alert list time filter "Between" mode when neither the from date nor the to date has been provided with a valid value.',
	},
	validNumber: {
		id: `eoc.alert-list.common.utils.validation-not-number`,
		defaultMessage: 'Enter a valid number.',
		description:
			'The error message that shown when user write different chars other than numeric chars.',
	},
	hoursNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range`,
		defaultMessage: 'Enter a number between 1-99999.',
		description: 'Message displayed to the user when hours value is not in range',
	},
	daysNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-days-not-in-range`,
		defaultMessage: 'Enter a number between 1-9999.',
		description: 'Message displayed to the user when days value is not in range',
	},
	weeksNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range`,
		defaultMessage: 'Enter a number between 1-999.',
		description: 'Message displayed to the user when weeks value is not in range',
	},
	monthsNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-months-not-in-range`,
		defaultMessage: 'Enter a number between 1-99.',
		description: 'Message displayed to the user when months value is not in range',
	},
	yearsNotInRange: {
		id: `eoc.alert-list.common.utils.validation-message-years-not-in-range`,
		defaultMessage: 'Enter a number between 1-9.',
		description: 'Message displayed to the user when years value is not in range',
	},
});

export default messages;
